import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { HrmTaxTable } from "../../../models/hrm-tax-table.model";

@Component({
  selector: "ngx-hrm-tax-table-form",
  templateUrl: "./hrm-tax-table-form.component.html",
  styleUrls: ["./hrm-tax-table-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrmTaxTableFormComponent extends BaseFormComponent<HrmTaxTable> {
  public apiName: string = "HrmTaxTable";
  public label: string = "جدول مالیاتی";
  DefaultValues: Dictionary = [];
  HrmTaxTableDetails: form_control[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.DefaultValues["HrmTaxTableId"] = 0;
    this.DefaultValues["Amount"] = 0;

    super.ngOnInit();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DefaultValues = undefined;
    this.HrmTaxTableDetails = undefined;
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.HrmTaxTableDetails = this.getDetailControlModels("HrmTaxTableDetails");
  }
  setdefault() {
    if (!this.model.HrmTaxTableDetails) this.model.HrmTaxTableDetails = [];
  }
  valueChanges($event) {
    if ($event && $event.controls["ToAmount"]?.value && $event.controls["FromAmount"]?.value && $event.controls["Prercent"]?.value) {
      $event
        .get("Amount")
        .setValue((($event.controls["ToAmount"].value - $event.controls["FromAmount"].value) * $event.controls["Prercent"]?.value) / 100);
    }
  }
}
